import { Tooltip } from 'antd';
import { useCopyText } from 'hooks/useCopyText';
import { Copy } from 'lucide-react';
import { cx } from '@emotion/css';
import { getPopupContainer } from '../utils/popover';

interface CopyTextProps {
  className?: React.HTMLAttributes<HTMLDivElement>['className'];
  style?: React.CSSProperties;
  text: string;
  tooltip?: string;
  showIcon?: boolean;
  ellipsis?: boolean;
  title?: string;
  keepIcon?: boolean;
}

export const CopyText = (props: CopyTextProps) => {
  const {
    className,
    text,
    style,
    tooltip,
    showIcon = true,
    ellipsis = true,
    title,
    keepIcon = false,
  } = props;

  const copyText = useCopyText();

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    copyText(text);
  };

  return (
    <Tooltip title={tooltip} getPopupContainer={getPopupContainer}>
      <div
        style={style}
        className={cx('group inline-flex items-center cursor-pointer max-w-fit', className)}
        onClick={handleClick}
        title={title}
      >
        <div className={cx(ellipsis && 'truncate')}>{text}</div>
        {showIcon ? (
          <Copy
            size={12}
            className={cx(
              'ml-[1px] flex-shrink-0 inline-block',
              keepIcon ? 'inline-block' : 'invisible group-hover:visible',
            )}
          />
        ) : null}
      </div>
    </Tooltip>
  );
};
